import React, { useContext, useState } from "react"
import { redirect, useNavigate } from "react-router-dom"
import { FiArrowRight, FiX } from "react-icons/fi"
import "./style.css"
import MaskCPF from "../../../inc/Mask/cpf"
import MaskPhone from "../../../inc/Mask/telefone"
import updateLead from "../../../inc/Fx/updateLead"
import api from "../../../services/api"
import encryptClass from "../../../inc/Controllers/encrypt.class"
import { GlobalContext } from "../../../contexts/global"
import validateCpf from "../../../inc/Fx/validateCpf"
import validatePhone from "../../../inc/Fx/validatePhone"
import Alert from "../../Global/Alert"

const Popup = props => {
  const [client_cpf, set_client_cpf] = useState(
    sessionStorage.getItem("client_cpf") !== null
      ? sessionStorage.getItem("client_cpf")
      : ""
  )
  const [client_phone, set_client_phone] = useState(
    sessionStorage.getItem("client_phone") !== null
      ? sessionStorage.getItem("client_phone")
      : ""
  )

  const [cpfError, setCpfError] = useState ("")
  const [isAlertOpen, setIsAlertOpen] = useState(false)
  const [is401Open, setIs401Open] = useState(false)

  let popupClassName = props.isOpen
    ? "site-popup-cpf popup-open"
    : "site-popup-cpf"

  const navigate = useNavigate()

  const close_popup = e => {
    e.preventDefault()
    props.toggle(false)
  }

  const { setPatientFound, setStatusSegmais, setLoaderState } = useContext(
    GlobalContext
  )

  const handleSubmit = async e => {
    e.preventDefault()
    setLoaderState(true)
    if(!validateCpf(client_cpf)){
      setCpfError("CPF inválido.")
      setIsAlertOpen(true)
      setLoaderState(false)
      return
    }

    const phoneError = validatePhone(client_phone)
    if (phoneError) {
      setCpfError(phoneError)
      setIsAlertOpen(true)
      setLoaderState(false)
      return
    }

    updateLead({
      CLIENT_CPF: client_cpf,
      CLIENT_PHONE: client_phone,
      FEEGOW_TIPO_AGENDAMENTO: "consultas-medicas"
    })

    const escClientCpf = client_cpf.replace(/\D/g, "")

    // [CONTENÇÃO 2026-07-06] auth desativada — religar no fix-forward.
    // Voltamos ao lookup pré-auth POST /patient (rota aberta no backend). O /auth/login
    // está dormente (backend contido em 2026-07-06: guards comentados, cookie ignorado). A tela neutra (is401Open)
    // é reaproveitada: dispara em success:false em vez de 401.
    // --- BLOCO AUTH ORIGINAL (religar no fix-forward) ---
    /*
    // Autentica via /auth/login (cookie HttpOnly setado pelo backend)
    try {
      const loginResp = await api.post("/auth/login", {
        cpf: escClientCpf,
        celular: client_phone.replace(/\D/g, "")
      })
      const { content } = loginResp.data

      let patientFound = encryptClass.hash(
        JSON.stringify({
          id: content.id,
          nome: content.nome,
          email: content.email,
          nasc: content.nasc,
          sexo: content.sexo
        })
      )

      sessionStorage.removeItem("client_name")
      sessionStorage.removeItem("client_email")
      sessionStorage.removeItem("client_nascimento")
      sessionStorage.removeItem("client_genre")
      sessionStorage.removeItem("patient")

      updateLead({
        FEEGOW_PATIENT_ID: content.id
      })
      setPatientFound(patientFound)
      sessionStorage.setItem("typeTabelaId", content.tabela_id)
      sessionStorage.setItem("patientFound", patientFound)
    } catch (err) {
      setLoaderState(false)
      if (err && err.response && err.response.status === 401) {
        setIs401Open(true)
        return
      }
      setCpfError("Erro ao validar dados. Tente novamente.")
      setIsAlertOpen(true)
      return
    }
    */
    // --- FIM BLOCO AUTH ORIGINAL ---

    // Lookup do paciente no Feegow (pré-auth, rota aberta).
    try {
      const feegowResp = await api.post("/patient", {
        client_cpf: escClientCpf
      })
      const { success, content } = feegowResp.data

      if (!success) {
        // Paciente não encontrado → tela neutra com escolha explícita.
        setLoaderState(false)
        setIs401Open(true)
        return
      }

      let patientFound = encryptClass.hash(
        JSON.stringify({
          id: content.id,
          nome: content.nome,
          email: content.email[0],
          nasc: content.nascimento,
          sexo: content.sexo
        })
      )

      sessionStorage.removeItem("client_name")
      sessionStorage.removeItem("client_email")
      sessionStorage.removeItem("client_nascimento")
      sessionStorage.removeItem("client_genre")
      sessionStorage.removeItem("patient")

      updateLead({
        FEEGOW_PATIENT_ID: content.id
      })
      setPatientFound(patientFound)
      sessionStorage.setItem("typeTabelaId", content.tabela_id)
      sessionStorage.setItem("patientFound", patientFound)
    } catch (err) {
      setLoaderState(false)
      setCpfError("Erro ao validar dados. Tente novamente.")
      setIsAlertOpen(true)
      return
    }

    // Detect segmais holding status
    const cfUrl = `/clubflex/${escClientCpf}`

    await api.get(cfUrl)
      .then(cfResp => {
        const { success, content } = cfResp.data
        setLoaderState(false)

        if (success) {
          let statusSegmais = encryptClass.hash(
            JSON.stringify({
              isSegMais: true,
              isSegMaisActive: content.status === "OK"
            })
          )
          sessionStorage.setItem("statusSegmais", statusSegmais)

          if(content.type === "PJ") {
            sessionStorage.setItem("statusSegmais", "PJ")
            sessionStorage.setItem("nome_Empresa", content.name)
          }
          if(content.status === "BLOCKED"){
            sessionStorage.setItem("statusSegmais", "BLOCKED")
          }

          sessionStorage.removeItem("convenio")
          setStatusSegmais(statusSegmais)
          updateLead({
            CLIENT_IS_CLUBFLEX: true,
            CLIENT_STATUS: content.status
          })

          navigate("/cadastro")
        } else {
          notClub()
        }
      })
      .catch(error => {
        console.error("Erro na verificação do SegMais:", error)
        setLoaderState(false)
        notClub()
      })

    // Função para tratar como particular em caso de falha
    function notClub() {
      sessionStorage.removeItem("statusSegmais")
      sessionStorage.removeItem("nome_Empresa")
      setStatusSegmais(null)
      updateLead({
        CLIENT_IS_CLUBFLEX: false
      })
      navigate("/convenio")
    }
  }

  return (
    <section className={popupClassName}>
      <div className="glass" onClick={close_popup}></div>
      <div className="content">
        <span className="close-button" onClick={close_popup}>
          <FiX size={44} />
        </span>
        <h2 className="popup-title">
          Por favor, <br /> informe os dados do <strong>paciente a ser atendido</strong>:
        </h2>
        <form onSubmit={handleSubmit} className="form-popup">
          <div className="popup-form-content">
            <div className="input-text" style={{ marginBottom: 40 }}>
              <label htmlFor="client_cpf">
                <p>CPF</p>
                <input
                  type="text"
                  inputMode="numeric"
                  name="client_cpf"
                  id="client_cpf"
                  autoComplete="off"
                  value={client_cpf}
                  placeholder="Digite seu CPF"
                  maxLength={14}
                  required
                  onBlur={sessionStorage.setItem("client_cpf", client_cpf)}
                  onChange={e => set_client_cpf(MaskCPF(e.target.value))}
                />
              </label>
            </div>
            <div className="input-text">
              <label htmlFor="client_phone">
                <p>Celular</p>
                <input
                  type="text"
                  inputMode="numeric"
                  name="client_phone"
                  id="client_phone"
                  value={client_phone}
                  placeholder="DDD + Celular"
                  maxLength={15}
                  onBlur={sessionStorage.setItem("client_phone", client_phone)}
                  required
                  onChange={e => set_client_phone(MaskPhone(e.target.value))}
                />
              </label>
            </div>
          </div>

          <p className="popup-warning">
            Certifique-se de utilizar o CPF e telefone cadastrados em nossos sistemas.
            Se você não lembra ou deseja mudar o telefone, entre em contato com nosso{" "}
            <a
              href="https://wa.me/552126665808?text=Quero falar sobre meu CPF/telefone cadastrado nos seus sistemas"
              target="_blank"
              rel="noopener noreferrer"
            >
              atendimento ao cliente
            </a>
            .
          </p>

          <div className="input-submit lightblue-submit">
            <button type="submit">
              Prosseguir
              <FiArrowRight />
            </button>
          </div>
        </form>
      </div>
      <Alert isOpen={isAlertOpen} onClose={setIsAlertOpen} title="Atenção!" >
        <p>{cpfError}</p>
      </Alert>
      <Alert isOpen={is401Open} onClose={setIs401Open} title="CPF ou celular inválidos" showOkButton={false}>
        <p>Verifique os dados digitados ou prossiga para cadastro.</p>
        <div className="alert-footer alert-footer-choice">
          <button onClick={() => setIs401Open(false)}>Tentar novamente</button>
          <button onClick={() => { setIs401Open(false); navigate("/cadastro") }}>
            Não tenho cadastro
          </button>
        </div>
      </Alert>
    </section>
  )
}

export default Popup
